/*eslint-disable eqeqeq */
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import RadioInput from '../../../../common/radio';
const Locations = ({ doctorDetails, onChangeHandler, currentAddressIndex }) => {
  return (
    <>
      <Row>
        {doctorDetails &&
          doctorDetails.DoctorAfflFacilities.map((location, index) => {
            return (
              <Col sm={12} className="each-doctor" key={index}>
                <div className="mt-3 mb-3 provider-location">
                  <RadioInput
                    inline
                    key={location.AddressLine1}
                    onChange={onChangeHandler}
                    label={`${location.AddressLine1},
                        ${location.City},
                        ${location.County},
                        ${location.State},
                        ${location.PostalCode}
                      `}
                    name="location"
                    value={index}
                    className="cursor-pointer d-flex provider-details-heading-location"
                    id={index}
                    checked={currentAddressIndex == index}
                  />
                  <div className="d-flex justify-content-between">
                    <span className="provider-details-data">
                      {doctorDetails.Phone1 && `Phone: ${doctorDetails.Phone1}`}
                    </span>
                  </div>
                  <span className="float-right provider-details-data">{`${
                    location.Distance
                  } mile${Number(location.Distance) > 1 ? 's' : ''} `}</span>
                </div>
              </Col>
            );
          })}
      </Row>
    </>
  );
};
export default Locations;
